import { VirtualFileAwareUniformPathBreadcrumb } from 'ts/commons/components/VirtualFileAwareUniformPathBreadcrumb';
import type { ExposedFindingFilterContext } from 'ts/commons/filters/findings/FindingsFilterContext';
import { openModal } from 'ts/commons/modal/ModalUtils';
import { PathUtils } from 'ts/commons/PathUtils';
import { UniformPath } from 'ts/commons/UniformPath';
import { Button } from 'ts/components/Button';
import { ModalActionButtons } from 'ts/components/Modal';
import type { ExtendedTrackedFinding } from 'typedefs/ExtendedTrackedFinding';

/** Dialog with breadcrumb for selection of a path */
export function openPathBreadcrumbModal(
	finding: ExtendedTrackedFinding,
	included: boolean,
	findingFilterContext: ExposedFindingFilterContext
) {
	const addPathCallback = (selectedPath: string) => findingFilterContext.addPath(selectedPath, included);
	const sections = UniformPath.splitIntoSegments(finding.location.uniformPath);
	openModal({
		title: 'Select path filter',
		size: 1200,
		contentRenderer: close => (
			<PathBreadcrumbDialog sections={sections} addPathCallback={addPathCallback} close={close} />
		)
	});
}

type PathBreadcrumbDialogProps = {
	addPathCallback: (selectedPath: string) => void;
	sections: string[];
	close: () => void;
};

function PathBreadcrumbDialog({ addPathCallback, sections, close }: PathBreadcrumbDialogProps) {
	return (
		<>
			<div className="flex flex-row justify-center">
				<VirtualFileAwareUniformPathBreadcrumb
					size="large"
					uniformPath={sections}
					getPropsForCrumb={(index, currentPath, isLastCrumb) => {
						let pathToComponent = PathUtils.joinPathSegments(currentPath);
						if (!isLastCrumb) {
							pathToComponent += '/**';
						}
						return { onClick: () => addPathCallback(pathToComponent) };
					}}
				/>
			</div>
			<ModalActionButtons>
				<Button onClick={close}>Cancel</Button>
			</ModalActionButtons>
		</>
	);
}
